<template>
  <div class="container-fluid">
    <template v-if="!showUploadPanel && currentDocuments.length > 0">
      <div
        v-for="(item, index) in currentDocuments"
        :key="item.id"
        class="container-uploaded-document"
      >
        <div class="row p-2 mt-2">
            <div class="col-md-4 col-sm-12 mt-2">
              <CustomInputDisplay
                v-model="item.documentType.name"
                label="Tipo de documento:"
                label-class="label-small"
              />
            </div>

            <div class="col-md-4 col-sm-12 mt-2">
              <CustomInputDisplay
                v-model="item.documentName"
                label="Archivo:"
                label-class="label-small"
              />
            </div>

            <div v-if="!isMobile" class="col-md-4 col-sm-12 mt-2">
              <div class="align-button">
                <DropDown :items="getActions(item)" title="Acciones" />
              </div>
            </div>

            <div class="col-md-12">
              <div class="divider-vertical py-2 w-100" />
            </div>
          </div>

          <div class="row p-2 mb-2 customChipPanel">
            <div class="col-4 ml-3">
              <CustomChipsGroup
                title="Evaluación(es) Seleccionada(s):"
                class="customChips-label"
                object-title="disciplineTypeName"
                object-text="evaluationDate"
                object-background-color="bgColor"
                :selected-items="item.evaluations"
                disabled
                no-background
                no-wrap
              />
            </div>
            <div class="col-6">
              <ErrorComponent
                v-if="!isValidMiunteDate(item.meetingDate)"
                class="px-3"
                message="El documento seleccionado no corresponde con la fecha de la discusión"
                :is-borderless="true"
              />
            </div>
            <div v-if="isMobile" class="col-md-4 col-sm-12 mt-2">
              <div class="align-button">
                <DropDown :items="getActions(item)" title="Acciones" />
              </div>
            </div>
          </div>
        </div>
    </template>

    <template v-if="showUploadPanel">
      <div
        class="d-flex container-document-button pl-3 pr-3 pb-3 pt-0 wrap-upload-panel"
      >
        <div class="bg-white p-2 upload-panel-container">
          <div class="row mt-2 px-2">
            <div class="col-md-3 col-sm-12">
              <template v-if="editableDocument">
                <CustomInputDisplay
                  v-model="file.documentType.name"
                  label="Tipo de documento:"
                  label-class="label-small"
                />
              </template>

              <template v-else>
                <ValidationProvider
                  ref="documentTypeValidator"
                  v-slot="{ errors }"
                  rules="required"
                >
                  <CustomDropDown
                    id="ddlTypeSelected"
                    v-model="file.documentType"
                    label="Tipo de documento:"
                    class="custom-dropDown-label"
                    placeholder="Seleccione"
                    required="required"
                    fieldkey="id"
                    fieldname="name"
                    :options="availableDocumentTypes"
                    :error="errors[0]"
                    custom-error-msg="El tipo de documento es requerido."
                  />
                </ValidationProvider>
              </template>
            </div>

            <div class="col-md-9 col-sm-12">
              <div v-if="isMinuteDocumentType && isCompuMinuteSystemSelectionEnabled">
                <CompuMinuteSelection
                  ref="compuMinuteSelection"
                  :value="file"
                  :student-sie-id="studentSieId"
                  :on-go-to-draft-minute="goToDraftMinute"
                  @input="onMinuteInputChange"
                  @delete="onMinuteDelete"
                  @selected-minute-changed="selectedMinute = $event"
                />
                <ErrorComponent
                  v-if="!isValidMiunteDate(selectedMinute?.meetingDate)"
                  class="px-3"
                  message="El documento seleccionado no corresponde con la fecha de la discusión"
                  :is-borderless="true"
                />
              </div>

              <div
                class="container-upload-document"
                v-if="!isCompuMinuteSystemSelectionEnabled || file.useSystemMinute === false || !isMinuteDocumentType"
              >
                <ValidationProvider
                  ref="documentValidator"
                  v-slot="{ errors }"
                  name="Documento"
                  rules="required"
                >
                  <CustomFileInput
                    :key="fileKey"
                    id="txtFileAttachment"
                    ref="fileUpload"
                    v-model="file.attachment"
                    class="custom-fileInput-label"
                    label="Archivo:"
                    required
                    :accept="'.pdf'"
                    display-style="normal"
                    label-position="left"
                    :error="errors[0]"
                    :add-text="'Presione aquí para añadir documento'"
                    custom-error-msg="El documento es requerido."
                    :on-download="downloadDocument"
                    :is-edit="editableDocument"
                    @after-remove="toggleEdit"
                  />
                </ValidationProvider>
              </div>
            </div>

            <div class="col-12">
              <div class="divider-vertical py-2 w-100" />
            </div>
          </div>

          <div class="row p-2">
            <div class="col-md-3 col-sm-12">
              <ValidationProvider
                ref="evaluationValidator"
                v-slot="{ errors }"
                :rules="validateEvaluationOptions ? 'required' : ''"
                mode="passive"
              >
                <CustomDropDown
                  id="ddlEvaluations"
                  v-model="selectedEvaluation"
                  class="mb-2 input-display custom-dropDown-label"
                  label="Documento de respaldo a:"
                  :regular-label="true"
                  placeholder="Seleccione"
                  required="required"
                  fieldkey="id"
                  fieldname="name"
                  :options="evaluationOptions"
                  :error="errors[0]"
                  custom-error-msg="Evaluación disponible es requerido."
                />
              </ValidationProvider>

              <div class="w-100 text-right">
                <ActionButton
                  v-if="!isMobile"
                  id="btnAddEvaluation"
                  variant="success"
                  i="fas fa-file-plus text-end"
                  @click="onAddEvaluationHandler"
                >
                  Añadir
                </ActionButton>
                <ActionButton
                  v-if="isMobile"
                  id="btnAddEvaluation"
                  variant="success btn-block"
                  i="fas fa-file-plus text-end"
                  @click="onAddEvaluationHandler"
                >
                  Añadir
                </ActionButton>
              </div>
            </div>

            <div class="col-1">
              <br />
              <div class="divider-horizontal" />
            </div>

            <div class="col-md-8 col-sm-12">
              <CustomChipsGroup
                title="Evaluación(es) Seleccionada(s):"
                class="customChips-label"
                object-title="disciplineTypeName"
                object-text="evaluationDate"
                :selected-items="addedEvaluations"
                :on-item-deleted="onRemoveEvaluationHandler"
                object-background-color="bgColor"
                no-background
                no-wrap
              />

              <template v-if="noEvaluationsAdded">
                <CustomError
                  variant="no-border"
                  message="Al menos una evaluación es requerida."
                />
              </template>
            </div>
          </div>

          <div v-if="isMobile" class="row px-10 pb-2 resizer">
            <div class="col-6 text-right pb-3">
              <ActionButton
                id="btnCancel"
                variant="outline-danger mr-2 btn-block"
                type="button"
                i="fas fa-times-circle"
                @click="onCancelHandler"
              >
                Cancelar
              </ActionButton>
            </div>

            <div class="col-6 text-right">
              <template v-if="editMode">
                <ActionButton
                  id="btnEditEvaluation"
                  variant="success btn-block"
                  i="fas fa-save text-end"
                  @click="onEditDocumentHandler"
                >
                  Guardar
                </ActionButton>
              </template>

              <template v-else>
                <ActionButton
                  id="btnAddEvaluation"
                  variant="success btn-block"
                  i="fas fa-file-plus text-end"
                  @click="onAddDocumentHandler"
                >
                  Añadir
                </ActionButton>
              </template>
            </div>
          </div>
          <div v-if="!isMobile" class="row px-10 pb-2 resizer">
            <div class="col-12 text-right pb-3">
              <ActionButton
                id="btnCancel"
                variant="outline-danger mr-2 "
                type="button"
                i="fas fa-times-circle"
                @click="onCancelHandler"
              >
                Cancelar
              </ActionButton>
              <template v-if="editMode">
                <ActionButton
                  id="btnEditEvaluation"
                  variant="success "
                  i="fas fa-save text-end"
                  @click="onEditDocumentHandler"
                >
                  Guardar
                </ActionButton>
              </template>

              <template v-else>
                <ActionButton
                  id="btnAddEvaluation"
                  variant="success "
                  i="fas fa-file-plus text-end"
                  @click="onAddDocumentHandler"
                >
                  Añadir
                </ActionButton>
              </template>
            </div>
          </div>
        </div>
      </div>
    </template>

    <template v-if="!showUploadPanel && currentDocuments.length == 0">
      <div class="row justify-content-center container-document-button">
        <div class="col-md-12 col-sm-12 text-center">
          <div class="d-flex" style="background-color: #fafafa">
            <ActionButton
              v-if="!isSubmitted"
              id="activationBtnShowUploadPanel"
              type="activationButton"
              text="Presione aquí para anejar documento"
              @click="onShowUploadPanel"
            />
          </div>
        </div>
      </div>
    </template>

    <template v-else-if="!showUploadPanel && currentDocuments.length > 0">
      <div class="row my-2 mt-5">
        <div class="col-md-12 col-sm-12 text-right">
          <ActionButton
            v-if="!isSubmitted"
            id="btnShowUploadPanel"
            variant="success"
            i="fas fa-file-plus text-end"
            @click="onShowUploadPanel"
          >
            Añadir
          </ActionButton>
        </div>
      </div>
    </template>

    <template v-if="showNeedDocumentError">
      <div class="row my-2">
        <div class="col-12">
          <ErrorComponent
            :message="rejectedEvaluationsErrorMessage"
            :is-borderless="true"
          />
        </div>
      </div>
    </template>
    <template v-if="showNonRecommendedNeedDocumentError">
      <div class="row my-2">
        <div class="col-12">
          <ErrorComponent
            :message="nonRecommendedEvaluationsErrorMessage"
            :is-borderless="true"
          />
        </div>
      </div>
    </template>
    <template v-if="isSubmitted && currentDocuments.length == 0">
      <div class="row d-flex justify-content-center mt-2 bg-gray">
        <div class="d-flex">
          <div class="col-md-12 col-sm-12 p-3 ml-3">
            <span class="no-info-text">
              No cuenta con documento de respaldo anejado en sistema.
            </span>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import ActionButton from "ActionButton";
import CustomFileInput from "CustomFileInput";
import CustomDropDown from "custom-drop-down";
import CustomChipsGroup from "CustomChipsGroup";
import CustomInputDisplay from "CustomInputDisplay";
import DropDown from "dropdown";
import CustomError from "custom-error";
import ErrorComponent from "@/components/common/Error";
import CompuMinuteSelection from "@/components/shared/CompuMinuteSelection.vue";
import compuMinuteService from "@/modules/compu-minutes-editor/api";
import alert from "@/mixin/alert.mixin";
import documentsService from "@/services/documents";
import { getEvaluationDiscussionDocumentTypes } from "@/modules/common/code.api.js";
import { getSysparameterByNames } from "@/modules/system-parameter-managment/api";

const recommendedColor = "#FFEBEB";
const pendingColor = "#FFF8E3";

const DocumentTypes = Object.freeze({
  Minuta: 66,
  Otros: 67,
});

export default {
  name: "EvaluationDocuments",
  mixins: [alert],
  components: {
    ActionButton,
    CustomFileInput,
    CustomDropDown,
    CustomChipsGroup,
    CustomInputDisplay,
    DropDown,
    CustomError,
    ErrorComponent,
    CompuMinuteSelection,
  },
  props: {
    evaluations: {
      type: Array,
      default: () => [],
    },
    currentDocuments: {
      type: Array,
      default: () => [],
    },
    evaluationsWithoutDocuments: {
      type: Array,
      default: () => [],
    },
    nonRecommendedWithoutDocuments: {
      type: Array,
      default: () => [],
    },
    nonRecommendedWithoutDocuments: {
      type: Array,
      default: () => [],
    },
    isSubmitted: {
      type: Boolean,
      default: false,
    },
    showError: {
      type: Boolean,
      default: false,
    },
    studentSieId: {
      type: [Number, String],
      default: null,
    },
    evaluationDate: {
      type: String,
      default: null,
    }
  },
  data() {
    return {
      showUploadPanel: false,
      editableDocument: false,
      editMode: false,
      validateEvaluationOptions: true,
      file: {
        type: null,
        attachment: null,
        documentType: null,
        useSystemMinute: null,
        compuMinuteId: null,
        fileId: null,
        fileName: null,
      },
      collections: {
        documentTypes: [],
      },
      selectedEvaluation: null,
      addedEvaluations: [],
      noEvaluationsAdded: false,
      availableDocumentTypes: [],
      sysParameters: [],
      fileKey: 0,
      oldMinute: null,
      selectedMinute: null,
      editingDocumentId: null,
    };
  },
  computed: {
    isMobile() {
      return this.$store.getters.getIsMobileDensity;
    },
    evaluationOptions() {
      const filtered = this.evaluations.filter(
        (x) =>
          !this.addedEvaluations.some((y) => y.id == x.studentEvaluationId) &&
          !this.currentDocuments.some(
            (d) =>
              d.evaluations.some((e) => e.id == x.studentEvaluationId) &&
              d.documentType.id == 1
          ) &&
          !this.currentDocuments.some(
            (d) =>
              d.evaluations.some((e) => e.id == x.studentEvaluationId) &&
              d.documentType.id == 2
          )
      );
      const evaluations = filtered.map((x) => ({
        id: x.studentEvaluationId,
        name: `${x.evaluationDate} - ${x.disciplineTypeName}`,
        disciplineTypeName: x.disciplineTypeName,
        disciplineTypeId: x.disciplineTypeId,
        evaluationDate: x.evaluationDate,
        bgColor: x.reevaluationRequired ? recommendedColor : pendingColor,
      }));

      return evaluations;
    },
    rejectedEvaluationsErrorMessage() {
      const evaluations = this.evaluationsWithoutDocuments.join(", ");
      const message = `Hubo un rechazo en la(s) discusión(es) de la(s) evaluación(es) ${evaluations}, favor anejar una minuta de reunión.`;

      return message;
    },
    nonRecommendedEvaluationsErrorMessage() {
      const evaluations = this.nonRecommendedWithoutDocuments.join(", ");
      const message = `La discusión(es) de la(s) evaluación(es) ${evaluations} no está(n) recomendada(s), favor anejar una minuta de reunión.`;

      return message;
    },
    showNeedDocumentError() {
      return this.showError && this.evaluationsWithoutDocuments.length > 0;
    },
    showNonRecommendedNeedDocumentError() {
      return this.showError && this.nonRecommendedWithoutDocuments.length > 0;
    },
    isCompuMinuteSystemSelectionEnabled() {
      let obj = this.sysParameters.find(
        (item) => item.name === 'ActiveCompuMinuteSystemSelection'
      );
      return obj?.staticValue?.toLowerCase() === 'true' ?? false;
    },
    isMinuteDocumentType() {
      return this.file.documentType?.id === DocumentTypes.Minuta;
    },
  },
  watch: {
    'file.useSystemMinute': {
      handler(newValue, oldValue) {
        if (oldValue === true && newValue === false) {
          this.toggleEdit();
          this.fileKey++;
        }
      },
    },
  },
  methods: {
    async getDocumentTypes() {
      const { data } = await getEvaluationDiscussionDocumentTypes();
      this.collections.documentTypes = [...data];
    },
    getActions(item) {
      let actions = [
        {
          label: "Descargar",
          icon: "fas fa-file-download text-green",
          border: "none",
          click: () => {
            this.downloadDocument(item);
          },
        },
        {
          label: "Editar",
          icon: "fas fa-edit text-green",
          visible: !this.isSubmitted,
          border: "none",
          click: () => {
            this.editDocument(item);
          },
        },
        {
          label: "Eliminar",
          icon: "fas fa-times-circle text-red",
          visible: !this.isSubmitted,
          border: "none",
          click: () => {
            this.removeDocument(item);
          },
        },
      ];

      return actions;
    },
    async gettingBackupDocument(data) {
      this.backupDocument.data = data;
    },
    async onAddEvaluationHandler() {
      const { valid } = await this.$refs.evaluationValidator.validate();

      if (!valid) return;

      const evaluationItem = {
        ...this.selectedEvaluation,
      };

      this.addedEvaluations.push(evaluationItem);

      this.selectedEvaluation = null;
    },
    onRemoveEvaluationHandler(item) {
      const filteredAddedEvaluations = this.addedEvaluations.filter(
        (x) => x.id != item.id
      );

      this.addedEvaluations = [...filteredAddedEvaluations];
    },
    async onCancelHandler() {
      this.file.documentType = null;
      this.file.attachment = null;
      this.selectedEvaluation = null;
      this.addedEvaluations = [];
      this.noEvaluationsAdded = false;
      this.editingDocumentId = null;

      await this.$nextTick(() => {
        if (!this.$refs.fileUpload) return;

        this.$refs.fileUpload.file = null;
        this.$refs.fileUpload.fileLabel = null;
      });

      this.editableDocument = false;
      this.showUploadPanel = false;
      this.selectedMinute = null;
    },
    async validateForm() {
      const validDocumentType = this.editableDocument
        ? { valid: true }
        : await this.$refs.documentTypeValidator.validate();
      const validDocument = await this.$refs.documentValidator?.validate() ?? { valid: true };
      const validMinuteSelection = await this.$refs.compuMinuteSelection?.validate() ?? true;

      this.noEvaluationsAdded = this.addedEvaluations.length == 0;

      return (
        validDocumentType.valid &&
        validDocument.valid &&
        validMinuteSelection &&
        !this.noEvaluationsAdded
      );
    },
    async onAddDocumentHandler() {
      const valid = await this.validateForm();
      if (!valid || !this.isValidMiunteDate(this.selectedMinute?.meetingDate)) return;

      const dto = this.mapDocumentToDto();
      this.$emit("on-add-document", dto);
      this.setEmptyDocument();
    },
    onShowUploadPanel() {
      this.showUploadPanel = !this.showUploadPanel;

      const filtered = this.collections.documentTypes.filter(
        (x) =>
          !this.currentDocuments.some(
            (obj) => obj.documentType.id == x.id && x.id !== DocumentTypes.Otros
          )
      );

      this.availableDocumentTypes = [...filtered];
    },
    async onEditDocumentHandler() {
      const valid = await this.validateForm();
      if (!valid || !this.isValidMiunteDate(this.selectedMinute?.meetingDate)) return;

      const dto = this.mapDocumentToDto();
      this.$emit("on-edit-document", dto);
      this.onCancelHandler();
    },
    async downloadDocument(item) {
      const documentId = item.documentId ?? item.documentAttachmentId;
      if (documentId) {
        documentsService.downloadDocumentByAttachmentIdOrDocumentId(documentId);
      } else {
        let file = {
          filename: item.documentName || item.name,
          content: item.attachment || item,
          contentType: "application/pdf",
        };
        documentsService.downloadFile(file);
      }
    },
    async editDocument(item) {
      this.oldMinute = {...this.selectedMinute};
      this.editableDocument = true;
      this.editMode = true;
      this.showUploadPanel = true;
      this.editingDocumentId = item.id;

      this.addedEvaluations = [...item.evaluations];
      this.file.documentType = item.documentType;
      this.file.attachment = item.attachment;
      this.file.useSystemMinute = item.useSystemMinute;
      this.file.compuMinuteId = item.compuMinuteId;
      this.file.fileId = item.fileId;
      this.file.fileName = item.documentName;

      await this.$nextTick(() => {
        if (!this.$refs.fileUpload) return;

        this.$refs.fileUpload.file = item.attachment ?? null;
        this.$refs.fileUpload.fileLabel = item.attachment?.name ?? null;
      });
    },
    toggleEdit() {
      if (this.editableDocument) {
        this.editableDocument = false;
      }
    },
    async removeDocument(item) {
      const res = await this.ShowCancelModal(
        "Alerta",
        `¿Está seguro que desea eliminar el documento ${item.documentName}?`,
        "Sí",
        "No"
      );

      if (res) {
        this.$emit("on-remove-document", item);

        this.ShowToast(
          "Proceso Exitoso",
          "El documento ha sido eliminado exitosamente.",
          "success"
        );
        this.selectedMinute = null;
      }
    },
    async setEmptyDocument() {
      this.resetFileData();
      this.selectedEvaluation = null;
      this.addedEvaluations = [];
      this.noEvaluationsAdded = false;
      this.editingDocumentId = null;

      this.editableDocument = false;
      this.showUploadPanel = false;
      this.selectedMinute = null;
    },
    mapDocumentToDto() {
      const meetingDate = !!this.file.useSystemMinute ? this.selectedMinute?.meetingDate : null;
      const dto = {
        id: this.editingDocumentId || Date.now() + Math.random(), // ID existente o nuevo
        documentType: this.file.documentType,
        documentName: !!this.file.useSystemMinute ? this.file.fileName : this.file.attachment?.name ?? null,
        attachment: !!this.file.useSystemMinute ? null : this.file.attachment,
        evaluations: [...this.addedEvaluations],
        compuMinuteId: !!this.file.useSystemMinute ? this.file.compuMinuteId : null,
        fileId: !!this.file.useSystemMinute ? this.file.fileId : null,
        useSystemMinute: this.file.useSystemMinute,
        meetingDate: meetingDate,
        isValidMiunteDate: this.isValidMiunteDate(meetingDate)
      };

      return dto;
    },
    resetFileData() {
      this.file.type = null;
      this.file.attachment = null;
      this.file.documentType = null;
      this.file.useSystemMinute = null;
      this.file.compuMinuteId = null;
      this.file.fileId = null;
      this.file.fileName = null;
      this.selectedMinute = null;
    },
    async goToDraftMinute() {
      if (!this.evaluationDate) {
        this.ShowToast(
          "Alerta",
          "La fecha de la discusión es requerida para redactar la minuta.",
          "error"
        );
        return;
      }

      const response = await compuMinuteService
        .getOrCreateDraftFromEvaluationDiscussion({
          studentSieId: Number(this.studentSieId),
          date: this.evaluationDate,
        })
        .catch((err) => {
          this.ShowToast(
            "Error",
            err?.response?.data?.message ||
              "No fue posible crear la minuta de COMPU.",
            "error"
          );
        });

      const id = response?.data?.id ?? response?.data;
      if (!id) return;

      this.$router.push(`/pei/compu-minutes-editor/${id}`);
    },
    onMinuteInputChange(data) {
      this.file = { ...this.file, ...data };
    },
    onMinuteDelete() {
      this.file.fileId = null;
      this.file.fileName = null;
      this.file.compuMinuteId = null;
      this.file.useSystemMinute = null;
      this.selectedMinute = null;
    },
    async fetchParams() {
      const { data: sysParameters } = await getSysparameterByNames({
        parameterNames: ['ActiveCompuMinuteSystemSelection'],
      });
  
      this.sysParameters = sysParameters;
    },
    validDocumentDates() {
      let isValid = true;
      this.currentDocuments.forEach((element) => {
        if (!this.isValidMiunteDate(element.meetingDate)) {
          isValid = isValid && false;
        }
      });

      return isValid;
    },
    isValidMiunteDate(meetingDate) {
      if (!meetingDate || !this.evaluationDate) {
        return true;
      }

      // 1. Convertimos ambos valores a objetos Date reales
      const date1 = new Date(meetingDate);
      const date2 = new Date(this.evaluationDate);

      // 2. Validamos que ambas fechas sean válidas antes de comparar
      if (isNaN(date1) || isNaN(date2)) {
        return false;
      }

      // 3. Comparamos estrictamente año, mes y día
      return (
        date1.getFullYear() === date2.getFullYear() &&
        date1.getMonth() === date2.getMonth() &&
        date1.getDate() === date2.getDate()
      );
    },
  },
  async mounted() {
    await this.getDocumentTypes();
    this.setEmptyDocument();

    await this.fetchParams();
  },
};
</script>

<style scoped lang="scss">
@use "sass:map";
@import "@/assets/scss/variables/_colors.scss";

.divider-vertical {
  border-bottom: 1px solid map.get($colors, "gray-5");
}

.divider-horizontal {
  border-right: 1px solid map.get($colors, "gray-5");
  margin-left: 50%;
  margin-right: 50%;
  height: 81%;
}

.dropdown-item.active,
.dropdown-item:active {
  background-color: #b7c7bf;
}
.dropdown-item .cursor-pointer {
  border-bottom: 1px solid #e2e2e2;
}
.bg-gray {
  background: #f2f2f2;
}
.no-info-text {
  text-align: left;
  font: Bold 16px/22px Lato;
  letter-spacing: 0;
  color: #727272;
  opacity: 1;
}
.customChipPanel {
  margin-top: -1.5rem;
  margin-bottom: -1.5rem;
}
.custom-dropDown-label ::v-deep {
  .data-name {
    font-size: 0.875rem !important;
  }
}
.custom-fileInput-label ::v-deep {
  .input-label {
    font-size: 0.875rem !important;
    font-weight: normal !important;
  }
}
.customChips-label ::v-deep {
  .chips-container p {
    font-size: 0.875rem !important;
    font-weight: normal !important;
  }
}
.resizer {
  width: 107%;
}
.evaluetion-unaviable {
  width: 100%;
}
.container-document-button {
  background-color: #ffffff;
  border-radius: 5px;
  padding: 6px;
}
.container-upload-document {
  width: 100%;
  //margin-left: 100px;
}
.wrap-upload-panel {
  width: 101.5%;
  margin-left: -13px;
}
.upload-panel-container {
  width: 100%;
}
.container-uploaded-document {
  background-color: rgb(255 255 255);
  border-bottom: 1px solid #d5cbcb;
  margin-left: -17px;
  margin-bottom: 20px;
}
@media only screen and (min-width: 600px) {
  .resizer {
    width: 50%;
    margin-left: auto;
  }
  .container-upload-document {
    width: 50%;
    margin-left: 100px;
  }

  .align-button {
    position: relative;
    left: 66.5%;
  }
  .container-uploaded-document {
    background-color: rgb(255 255 255);
    border-bottom: 1px solid #d5cbcb;
    margin-left: -13px;
    margin-bottom: 20px;
  }
}
</style>
